enum CustomViewAccessType {
  ViewOnly = 1,
  Editor = 2,
  Owner = 3,
}

export default CustomViewAccessType;
